const PLAYERJS_SRC = 'https://assets.mediadelivery.net/playerjs/player-0.1.0.min.js';

// Module-level Promise: das player.js-Skript wird garantiert nur einmal geladen,
// auch wenn mehrere Hooks/Komponenten es gleichzeitig anfragen.
let playerJsPromise: Promise<PlayerJsNamespace | null> | null = null;

/**
 * Lädt das Bunny-player.js-Skript und liefert dessen globalen Namespace.
 * Lehnt niemals ab — schlägt das Laden fehl, wird null geliefert.
 */
export function loadPlayerJs(): Promise<PlayerJsNamespace | null> {
  if (playerJsPromise !== null) {
    return playerJsPromise;
  }

  playerJsPromise = new Promise<PlayerJsNamespace | null>((resolve) => {
    if (window.playerjs !== undefined) {
      resolve(window.playerjs);
      return;
    }

    const script = document.createElement('script');
    script.src = PLAYERJS_SRC;
    script.async = true;
    script.addEventListener('load', () => {
      resolve(window.playerjs ?? null);
    });
    script.addEventListener('error', () => {
      resolve(null);
    });
    document.head.appendChild(script);
  });

  return playerJsPromise;
}
